module.exports = __webpack_public_path__ + "img/home-restaurant-thumb-01.5db3af10.jpg";